import { FormlyFieldConfigMap } from './formly-field-config.map';

const LanguageAssignmentsPlaceHolder = 'Search for a Location';

export const languageAssignmentsFilterFieldMap: FormlyFieldConfigMap<any> = {
    name: () => ({
        key: 'name',
        templateOptions: {
            label: 'Name or Number',
            maxLength: 512,
            placeholder: LanguageAssignmentsPlaceHolder
        },
        type: 'input',
        wrappers: ['form-field-filter']
    })
};
